export const AUTH_COOKIE_NAME = 'x-auth-token';

const AUTH_COOKIE_READ_NAMES: string[] = [AUTH_COOKIE_NAME, 'X-Auth-Token'];

function isLocalHost(hostname: string): boolean {
    return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function resolveAuthCookieDomain(hostname: string): string | null {
    if (isLocalHost(hostname)) {
        return null;
    }

    const host = hostname.toLowerCase();
    if (host === 'vikingcloud.com' || host.endsWith('.vikingcloud.com')) {
        return '.vikingcloud.com';
    }

    return null;
}

function cookieAttributeSuffix(hostname: string): string {
    const parts = ['Path=/', 'SameSite=Lax'];
    const domain = resolveAuthCookieDomain(hostname);
    if (!isLocalHost(hostname)) {
        parts.push('Secure');
    }
    if (domain) {
        parts.push(`Domain=${domain}`);
    }
    return parts.join('; ');
}

export function writeAuthCookie(doc: Document, token: string): void {
    const encoded = encodeURIComponent(token);
    doc.cookie = `${AUTH_COOKIE_NAME}=${encoded}; ${cookieAttributeSuffix(doc.location.hostname)}`;
}

export function readAuthCookie(doc: Document): string | null {
    if (!doc.cookie) {
        return null;
    }

    const cookies = doc.cookie.split(';').map((entry) => entry.trim());
    for (const name of AUTH_COOKIE_READ_NAMES) {
        const prefix = `${name}=`;
        const match = cookies.find((entry) => entry.startsWith(prefix));
        if (!match) {
            continue;
        }

        const value = match.slice(prefix.length);
        try {
            return decodeURIComponent(value);
        } catch {
            return value;
        }
    }

    return null;
}

export function clearAuthCookie(doc: Document): void {
    const suffix = cookieAttributeSuffix(doc.location.hostname);
    for (const name of AUTH_COOKIE_READ_NAMES) {
        doc.cookie = `${name}=; Max-Age=0; ${suffix}`;
    }
}
